import React, { useCallback, useEffect, useState } from 'react';
import { Check, ListChecks, Loader2, Users, X } from 'lucide-react';
import { apiService } from '../../services/api';

// Engagements pris en réunion tactique qui ne sont pas devenus des tâches : relevés après coup par Nexus dans la
// transcription de qualité, proposés à la personne concernée. Rien n'est créé sans clic.
const fullDay = (iso) => (iso ? new Date(`${iso}T12:00:00`).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long' }) : '');

const TacticalProposals = ({ onTaskCreated }) => {
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(null);
  const [error, setError] = useState(null);

  const load = useCallback(() => apiService.get('/home/tactical-proposals').then((rows) => setItems(rows || []))
    .catch(() => setItems([])), []);
  useEffect(() => { load(); }, [load]);

  const decide = async (item, accept) => {
    setBusy(item.id);
    setError(null);
    try {
      await apiService.post(`/home/tactical-proposals/${item.id}`, { accept });
      setItems((all) => all.filter((i) => i.id !== item.id));
      if (accept && onTaskCreated) onTaskCreated();
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(null);
    }
  };

  if (!items.length) return null;
  return (
    <section className="rounded-2xl border border-slate-100 bg-white p-4 shadow-sm">
      <h2 className="flex items-center gap-2 text-sm font-semibold text-slate-800">
        <Users size={15} className="text-indigo-500" /> Dit en réunion tactique
        <span className="text-xs font-normal text-slate-400">· pas encore une tâche</span>
      </h2>
      <ul className="mt-2 space-y-1.5">
        {items.map((item) => (
          <li key={item.id} className="flex items-start gap-2 rounded-lg bg-slate-50 px-3 py-2 text-sm">
            <ListChecks size={15} className="mt-0.5 shrink-0 text-slate-400" />
            <div className="min-w-0 flex-1">
              <p className="text-slate-800">{item.title}</p>
              <p className="text-xs text-slate-500">
                {item.project_name || 'Sans projet'}
                {item.due_date && ` · pour le ${fullDay(item.due_date)}`}
                {item.meeting_date && ` · tactique du ${fullDay(item.meeting_date)}`}
              </p>
            </div>
            <button type="button" onClick={() => decide(item, true)} disabled={busy === item.id}
              className="inline-flex items-center gap-1 rounded-md bg-indigo-600 px-2.5 py-1 text-xs font-medium text-white hover:bg-indigo-700 disabled:opacity-50">
              {busy === item.id ? <Loader2 size={12} className="animate-spin" /> : <Check size={12} />} Créer la tâche
            </button>
            <button type="button" onClick={() => decide(item, false)} disabled={busy === item.id} title="Pas pour moi / déjà fait"
              className="rounded-md p-1 text-slate-400 hover:bg-slate-200 hover:text-slate-700">
              <X size={14} />
            </button>
          </li>
        ))}
      </ul>
      {error && <p className="mt-1 text-xs text-rose-600">{error}</p>}
    </section>
  );
};

export default TacticalProposals;
